export default __webpack_public_path__ + "static/media/clean.a212b0bf.jpg";